import { useMutation, useQueryClient } from 'react-query';

import { deleteJson } from '@zapier/toolbox-browser-fetch';

import { ZAPIER_APP_BASE_URL } from 'app/common/constants';
import { useActiveProfile, useNotify } from 'app/developer-v3/hooks';
import { Status } from 'app/zap-templates/types';

import { getQueryKey } from './useQueryZapTemplates';

type Args = { id: string; status: Status };
type Return = Record<string, any>;

const MUTATION_KEY = 'delete-zap-template';
function useDeleteZapTemplate() {
  const notify = useNotify();
  const queryClient = useQueryClient();
  const mutationKey = MUTATION_KEY;
  const { activeProfile } = useActiveProfile();

  const mutation = useMutation<Return, Error, Args>({
    mutationKey,
    async mutationFn({ id }) {
      const url = new URL(
        `/api/developer/v1/guided-zaps/${encodeURIComponent(id)}`,
        ZAPIER_APP_BASE_URL
      );

      return await deleteJson(url.href);
    },
    onError(_err, { id }) {
      notify.failure(`Failed to delete the Zap template. ID: ${id}.`);
    },
    onSuccess(_data) {
      const queryKeyZapTemplates = getQueryKey(activeProfile?.id);
      queryClient.invalidateQueries(queryKeyZapTemplates);
      notify.success('Successfully deleted the Zap template.');
    },
  });

  const { isLoading } = mutation;

  return { isMutating: isLoading, mutate: mutation.mutateAsync, mutationKey };
}

export default useDeleteZapTemplate;
